export const interfaceEN = {
  MAIN_TITLE: "Capital Quiz 2.0",
  OPTIONS: "Options",
  IRON_MAN_MODE: "Iron Man Mode",
  IRON_MAN_MODE_DESC: "195 questions. 50/50 doesn't work. One wrong answer and you lose. How long can you stand?",
  NORMAL_QUIZ: "Normal Quiz",
  CHANGE_LANGUAGE: "Русский Язык",
  I_WANT_TO_KNOW: "I want to know",
  NUMBER_OF_QUESTIONS: "Number of questions",
  FLIP: "Flip the question",
  FLIP_DESC: "Now you know the capital. But what about the country?",
  SHOW5050: "Show 50/50",
  BUTTON_5050: "50/50",
  SHOW5050_DESC: "Let us give you a little help. 2 answers instead of 4.",
  HIDE_LETTERS: "Hide letters",
  HIDE_LETTERS_DESC: "Some like it hot. You see only the first and the last letter.",
  START_QUIZ: "Start the Quiz!",
  RIGHT: "Right",
  WRONG: "Wrong",
  OUT_OF: "out of",
  BACK_TO_START: "Back to Start",
  PLAY_AGAIN: "Play Again",
  LONGEST_STREAK_001: "Your longest Iron Man Mode win streak is ",
  LONGEST_STREAK_002: " questions.",
  QUESTIONS_CORRECT: "questions correct.",
  CLEAR_STREAK: "Clear Streak",
  QUESTION_TEXT: "What is the capital of",
  QUESTION_TEXT_FLIP: "is the capital of which country?",
  STATISTICS: "Statistics",
  All_TIME_RIGHT_ANSWERS: "All time right answers:",
  All_TIME_WRONG_ANSWERS: "All time wrong answers:",
  RIGHT_ANSWERS_ON_AVERAGE: "Right answers on average, %",
  LONGEST_IRON_MAN: "Longest Iron Man win streak: ",
  OPTION5050_USED: "50/50 used:",
  GAMES_FINISHED: "Games finished: ",
  IRON_MAN_ATTEMPTS: "Iron Man attempts: ",
};

export const interfaceRU = {
  MAIN_TITLE: "Столица Квиз 2.0",
  OPTIONS: "Настройки",
  IRON_MAN_MODE: "Железные Яйца",
  IRON_MAN_MODE_DESC: "195 вопросов. 50/50 не работает. Одна ошибка и проигрыш. Сколько сможете продержаться?",
  NORMAL_QUIZ: "Обычный Квиз",
  CHANGE_LANGUAGE: "English",
  I_WANT_TO_KNOW: "Хочу узнать",
  NUMBER_OF_QUESTIONS: "Количество вопросов",
  FLIP: "Наоборот",
  FLIP_DESC: "Столица известна, отгадайте страну.",
  SHOW5050: "Показать 50/50",
  BUTTON_5050: "50/50",
  SHOW5050_DESC: "Немного помощи не помешает. 2 ответа вместо 4-х.",
  HIDE_LETTERS: "Спрятать буквы",
  HIDE_LETTERS_DESC: "Для любителей трудностей. Видны только первая и последняя буквы ответа.",
  START_QUIZ: "Начать",
  RIGHT: "Верно",
  WRONG: "Неверно",
  OUT_OF: "из",
  BACK_TO_START: "Назад",
  PLAY_AGAIN: "Ещё раз",
  LONGEST_STREAK_001: "Ваше наибольшее количество верных ответов: ",
  LONGEST_STREAK_002: ".",
  QUESTIONS_CORRECT: "правильно.",
  CLEAR_STREAK: "Очистить запись",
  QUESTION_TEXT: "Какая столица этой страны:",
  QUESTION_TEXT_FLIP: "столица какой страны?",
  STATISTICS: "Статистика",
  All_TIME_RIGHT_ANSWERS: "Верных ответов за всё время:",
  All_TIME_WRONG_ANSWERS: "Неверных ответов за всё время:",
  RIGHT_ANSWERS_ON_AVERAGE: "Верных ответов в среднем, %",
  LONGEST_IRON_MAN: "Лучший результат ЖЯ: ",
  OPTION5050_USED: "50/50 использовано:",
  GAMES_FINISHED: "Всего игр закончено: ",
  IRON_MAN_ATTEMPTS: "Количество ЖЯ попыток: ",
};
